export default __webpack_public_path__ + "static/media/mobile.91402e04.svg";